import { useContext, useEffect, useState } from "react";
import * as React from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Button, MenuItem, TextField, Select } from "@mui/material";
import { CreateHirings } from "../../../API/HiringsAPI";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Contexts/AuthContext";
import Loader from "../../Shared/Loader";
import { GetAllByCompanyId } from "../../../API/PleaAPI";
import { PleaModel } from "../../../Models/PleaModel";

interface CreateHiringsModalProps {
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    getHirings: () => void;
}

export const CreateHiringsModal = ({ showModal, setShowModal, getHirings }: CreateHiringsModalProps) => {
    const { userEmail } = useContext(AuthContext);
    const [pleas, setPleas] = useState<PleaModel[]>([]);
    const [name, setName] = useState<string>("");
    const { id } = useParams()

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        GetAllByCompanyId(id ?? "")
            .then(response => setPleas(response.data));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function submitHiringsForm(e: any) {
        setLoading(true);
        // O NAVIGATE ESTÁ ANTES DA OPERAÇÃO PARA TESTE TEMPORÁRIO
        try {
            const pleaId = e.target.panel.value;

            CreateHirings(id ?? "", pleaId, name, userEmail)
                .then(response => {
                    toast.success('Registro criado com sucesso!');
                    setShowModal(false);
                    setLoading(false);
                    getHirings();
                })

        } catch (err: any) {
            toast.error(err)
        } finally {
            setLoading(false);
        }
    }
    return (
        <>
            {loading && <Loader />}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
            >
                <form onSubmit={submitHiringsForm}>
                    <Modal.Body>
                        <div className="d-flex align-items-center justify-content-center mb-4" style={{ marginTop: '20px', marginBottom: '46px' }}>
                            <h6 className='fw-bold'>Nova Contratação</h6>
                        </div>
                        <div className="text-center">
                            <TextField
                                id="panel-select"
                                label="Selecione o Pleito Correspondente"
                                className="w-100 mt-2"
                                select
                                name="panel"
                                required
                                InputProps={{
                                    style: { textAlign: 'left' }
                                }}
                            >
                                {pleas.map(panel => (
                                    <MenuItem key={panel.id} value={panel.id}>{panel.bankName} - {panel.version}</MenuItem>
                                ))}
                            </TextField>

                            <TextField
                                id="outlined-basic"
                                label="Nome da Contratação"
                                variant="outlined"
                                className="w-100 mt-2"
                                autoComplete="off"
                                name="namePlea"
                                onChange={(e) => setName(e.target.value)}
                                required
                            ></TextField>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="mt-2" >
                        <Button
                            variant="contained"
                            sx={{ borderRadius: '10px' }}
                            type="submit">Salvar
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
}